module.exports = __webpack_public_path__ + "static/media/New-intro-nonword-NN.9234a7da.mp3";